import { Controller } from "@hotwired/stimulus"

// Backs the "← Back" link rendered near the top of every page (see
// shared/_back_link) so users can navigate up through the app without
// reaching for the browser's own back button. Just delegates to browser
// history -- no server round trip, and it naturally lands wherever the
// user actually came from rather than a hardcoded "parent" page.
export default class extends Controller {
  go(event) {
    event.preventDefault()
    history.back()
  }
}
